import { CutleryImage } from "@/components/images/cutlery-image";
import { OutlinedButton } from "@/components/ui/buttons";
import { useGetDashboardMessages } from "@/hooks/requests/dashboard/use-get-dashboard-messages";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { IonSkeletonText, useIonRouter } from "@ionic/react";
import { memo } from "react";

const classNamesMap: { container: string; iconContainer: string; button: string }[] = [
  {
    container: "shadow-card start-0 bg-gradient-to-b from-white/40 to-white",
    iconContainer: "flex h-14 w-14 items-center justify-start rounded-full bg-white",
    button: "border-screen-gs-1 text-screen-gs-1 w-fit",
  },
  {
    container: "shadow-card start-0 bg-gradient-to-b from-[#F7F2FF]/8 to-white/8",
    iconContainer: "flex h-14 w-14 items-center justify-start rounded-full bg-[#4F257C]",
    button: "border-white text-white w-fit",
  },
];

interface MealTimeCardProps {
  isNew: boolean;
}

export const MealTimeCard = memo(function MealTimeCard({ isNew }: MealTimeCardProps) {
  const classNames = classNamesMap[isNew ? 1 : 0];
  const { dashboardMessages, isLoading } = useGetDashboardMessages();
  const navigate = useIonRouter();
  if (isLoading) {
    return <IonSkeletonText animated className="h-[250px] w-full rounded-2xl" />;
  }
  return (
    <div
      className={cn(
        "flex w-full flex-col items-center gap-4 rounded-4xl px-4 py-5",
        classNames.container,
      )}
    >
      <div className={classNames.iconContainer}>
        <CutleryImage className="h-13.5 w-10" />
      </div>

      <h2 className={cn(textVariants.title2, "max-w-[280px] text-center")}>
        {dashboardMessages?.title}
      </h2>

      <p className={cn(textVariants.bodySmall, "max-w-[280px] text-center")}>
        {dashboardMessages?.message}
      </p>

      <OutlinedButton
        color="black"
        bgColor="transparent"
        textCase="normal"
        borderRadius="wide"
        className={classNames.button}
        onClick={() => {
          navigate.push("/plans/my-plan", "none", "push");
        }}
      >
        Fancy something new?
      </OutlinedButton>
    </div>
  );
});
